var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardOutlined = function SvgCreditCardOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#145CC5",
    clipPath: "url(#creditCardOutlined_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.317 15.075h-.909a1.3 1.3 0 0 1-.875.334H5.467c-.334 0-.642-.125-.875-.334h-.909c-.258 0-.5-.05-.725-.141a2.655 2.655 0 0 0 2.509 1.808h9.075c1.166 0 2.15-.758 2.508-1.808a1.9 1.9 0 0 1-.725.141zM15.633 3.342H4.367a2.71 2.71 0 0 0-2.7 2.7v5.925a2.71 2.71 0 0 0 2.7 2.7h11.266a2.71 2.71 0 0 0 2.7-2.7V6.034a2.71 2.71 0 0 0-2.7-2.7zM17 11.967c0 .75-.608 1.367-1.367 1.367H4.367c-.75 0-1.367-.608-1.367-1.367V6.034c0-.75.608-1.367 1.367-1.367h11.266c.75 0 1.367.609 1.367 1.367v5.933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.758 6.326H5c-.367 0-.667.3-.667.667s.3.667.667.667h9.758c.367 0 .667-.3.667-.667s-.3-.667-.667-.667M9.375 9.908H5c-.367 0-.667.3-.667.667s.3.667.667.667h4.375c.367 0 .667-.3.667-.667s-.3-.667-.667-.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "creditCardOutlined_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgCreditCardOutlined;